// extracted by mini-css-extract-plugin
module.exports = {"root":"_2Rsps","position":"_31njN","title":"_7DY8u","image":"_2KpaQ","text":"-LjRZ","close":"RIYSe","closeIcon":"_2fP7r"};